<template>
  <tr @click="manageAppointment" class="is-clickable">
    <!-- Checkbox di selezione  -->
    <td @click.stop v-if="showCheckbox" class="text-no-wrap">
      <v-checkbox
        class="no-bottom pl-1 py-0"
        density="compact"
        hide-details
        @change="$emit('toggle-select', appointment.appointmentId)"
      ></v-checkbox>
    </td>
    <td>
      <appointment-sla :slaDetail="appointment.slaDetail" />
    </td>
    <td class="font-weight-medium">
      <span v-if="memberFullName" v-html="memberFullName"></span>
      <span v-else class="font-italic text-uppercase">
        {{ getNoDataMsg(true) }}
      </span>
    </td>
    <td class="font-weight-medium">
      <div class="service-name-container">
        <v-tooltip color="primary" bottom>
          <template v-slot:activator="{ on }">
            <div class="text-uppercase" v-on="on">
              {{ serviceName }}
            </div>
          </template>
          <span class="font-weight-bold text-uppercase caption">{{
            serviceName
          }}</span>
        </v-tooltip>
      </div>
    </td>
    <td class="text-no-wrap font-weight-medium">
      <span v-if="scheduleDate">
        {{ scheduleDate | date(dateFormat) }}
        <br />
        {{ scheduleDate | date(hourFormat) }}
      </span>
      <span v-else class="font-italic text-uppercase">
        {{ getNoDataMsg(false) }}
      </span>
    </td>
    <td class="text-no-wrap font-weight-medium">
      <span v-if="requestDate">
        {{ requestDate | date(dateFormat) }}
        <br />
        {{ requestDate | date(hourFormat) }}
      </span>
      <span v-else class="font-italic text-uppercase">{{
        getNoDataMsg(true)
      }}</span>
    </td>
    <td>
      <appointment-state-chip
        :state="appointment.state"
        :acceptedToWork="appointment.acceptedToWork"
      />
    </td>
  </tr>
</template>

<script>
import AppointmentSla from "./AppointmentSla";
import AppointmentStateChip from "./AppointmentStateChip";

export default {
  components: {
    AppointmentStateChip,
    AppointmentSla
  },
  props: {
    appointment: {
      type: Object,
      required: true
    },
    isSelected: Boolean,
    isBookingType: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    page: 1,
    dialog: false,
    dateFormat: "DD/MM/YYYY",
    hourFormat: "HH:mm"
  }),
  created() {},
  computed: {
    isXLargeDevice() {
      return this.$vuetify.breakpoint.xl;
    },
    requestDate() {
      return this.appointment?.appointmentRequestDate || null;
    },
    scheduleDate() {
      return this.appointment?.appointmentScheduleDate || null;
    },
    serviceName() {
      return this.appointment?.hService?.longDescr || null;
    },
    memberFullName() {
      if (this.appointment.memberSurname && this.appointment.memberName)
        return `${this.appointment?.memberSurname} ${this.appointment?.memberName}</br>${this.appointment.memberCodiceFiscale}`;
      else return null;
    },
    showCheckbox() {
      return this.isBookingType;
    }
  },
  methods: {
    manageAppointment() {
      this.$router.push({
        name: "_appointmentManagement",
        params: { id: this.appointment.appointmentId }
      });
    },
    getCTAbtnlabel() {
      const APPOINTMENT_STATE = this.appointment.state;
      return APPOINTMENT_STATE == "PENDING" ||
        APPOINTMENT_STATE == "ACCEPTED" ||
        APPOINTMENT_STATE == "MEMBERCHANGE" ||
        APPOINTMENT_STATE == "HFOFFICECHANGE" ||
        APPOINTMENT_STATE == "TOBERESCHEDULED"
        ? "manage"
        : "view";
    },
    isAppointmentBilled() {
      const APPOINTMENT_STATE = this.appointment.state;
      return APPOINTMENT_STATE == "INBILL";
    },
    getNoDataMsg(isRequired) {
      if (
        isRequired ||
        (this.appointment.appointmentScheduleDate && isRequired)
      )
        return this.$t("emptyData");
      else return "-";
    },
    toggleSelect() {
      this.$emit("toggle-select", this.appointment);
    }
  }
};
</script>

<style scoped>
:deep(.no-bottom .v-input__slot) {
  border-bottom: none;
  padding: 0;
}
.service-name-container {
  min-width: 400px;
}
</style>
